import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Link, Media, Title, Text } from '@deseretbook/react-ui'
import Address from './Address'

/**
 * Delivery information of shipment
 *
 * @returns {function} Component
 */
const DeliveryMethod = ({ shipAddress, shipment, shipmentIndex }) => {
  /** If shipment is digital */
  const isDigital = shipment.shippingMethod.adminName.includes('Digital')

  /** If shipment is in-store pickup */
  const isStorePickup = shipment.shippingMethod.adminName.includes('Store Pickup')

  /** If shipment is being shipped */
  const isShip = !shipment.shippingMethod.adminName.includes('Store Pickup') && !shipment.shippingMethod.adminName.includes('Digital')

  return (
    <React.Fragment>
      {isShip && (
        <React.Fragment>
          <Media style={{ marginBottom: 0 }}>
            <Media.Figure verticalAlignment="center" className="hidden-print">
              <Icon name="truck" color="primary" size="medium" />
            </Media.Figure>
            <Media.Content>
              <Title
                title={shipmentIndex >= 0
                  ? `Shipment ${shipmentIndex + 1}`
                  : 'Shipment Details'
                }
                size={2}
                aria-level={2}
              />
            </Media.Content>
          </Media>
          <Address address={shipAddress} />
          <Text hasEllipsis isItalic>Via {shipment.shippingMethod.name}</Text>
          <Text color="muted" size="tiny">We'll send an email when your items have shipped.</Text>
        </React.Fragment>
      )}
      {isStorePickup && (
        <React.Fragment>
          <Media style={{ marginBottom: 0 }}>
            <Media.Figure verticalAlignment="center">
              <Icon name="store" color="primary" size="medium" />
            </Media.Figure>
            <Media.Content>
              <Title
                title="Pickup Details"
                subtitle="We'll send an email when your items are ready."
                size={2}
              />
            </Media.Content>
          </Media>
          <Address address={shipment.retailStore} />
          <Text hasEllipsis>
            <Link href={`/retail_stores/${shipment.retailStore.id}`} target="_blank">View Store Information</Link>
          </Text>
        </React.Fragment>
      )}
      {isDigital && (
        <Title size={2} title="Digitally Delivered" />
      )}
    </React.Fragment>
  )
}

DeliveryMethod.propTypes = {
  shipAddress: PropTypes.shape({}),
  shipment: PropTypes.shape({
    shippingMethod: PropTypes.shape({
      adminName: PropTypes.string,
      name: PropTypes.string,
    }),
    retailStore: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  shipmentIndex: PropTypes.number,
}

DeliveryMethod.defaultProps = {
  shipAddress: {},
  shipment: {},
}

export default DeliveryMethod
